import { MoonIcon, SunIcon } from 'assets/icons';
import React from 'react';
import { useDispatch } from 'react-redux';
import { AppTheme } from 'shared/constants/common';
import useResolvedColorScheme from 'shared/hooks/useResolvedColorScheme';
import { handleAppTheme } from 'shared/store/navigation.action';
import './styles.scss';

const ThemeSwitch: React.FC = () => {
	const dispatch = useDispatch();
	const { resolvedColorScheme } = useResolvedColorScheme();

	const handleToggleDarkMode = (theme: AppTheme) => {
		dispatch(handleAppTheme(theme));
	};

	return (
		<div className="ThemeSwitch">
			{resolvedColorScheme === AppTheme.LIGHT ? (
				<MoonIcon onClick={() => handleToggleDarkMode(AppTheme.DARK)} />
			) : (
				<SunIcon onClick={() => handleToggleDarkMode(AppTheme.LIGHT)} />
			)}
		</div>
	);
};

export default ThemeSwitch;
